import "./sentiment.scss";
import SentimentComponent from "components/app/project/sentiment";
import ClipTray from "components/app/clip-tray";
import { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { RootState } from "types";
import FiltersMenu from "components/app/project/filters-menu";
import { SentimentType } from "types/sentiment";
import { useParams } from "react-router-dom";
import api from "api";
import Summary from "components/app/project/sentiment/widgets/summary";
import Heatmap from "components/app/project/sentiment/widgets/heatmap";
import DailyInsights from "components/app/project/sentiment/widgets/daily-insights";
import WorldMap from "components/app/project/sentiment/widgets/world-map";
import BreakdownPie from "components/app/project/sentiment/widgets/breakdown-pie";
import Subfolder from "components/app/project/subfolders";

function Sentiment() {
    const params = useParams<any>();
    const state = useSelector((state: RootState) => state);
    const [dateFrom, setDateFrom] = useState(moment().subtract(1, "d").set("h", 0).set("m", 0).set("s", 0));
    const [dateTo, setDateTo] = useState(moment());
    const [streamIds, setStreamIds] = useState<number[]>([7, 8, 9]);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sentiment, setSentiment] = useState<SentimentType[]>([]);
    const [subfolderId, setSubfolderId] = useState<number | null>(null);
    const filtersRef = useRef<any>();

    const getSentiment = useCallback(async () => {
        setLoading(true);
        const data = await api.sentiment.getAll(subfolderId ? subfolderId : params.projectId, dateFrom, dateTo, streamIds);
        setLoading(false);
        setSentiment(data);
    }, [params.projectId, dateFrom, dateTo, streamIds, subfolderId]);

    const setSubfolder = (subfolder: number) => {
        setSubfolderId(subfolder);
    };

    useEffect(() => {
        if (state.project) {
            if (state.project.ProjectTypeId === 5) {
                setStreamIds([7, 8, 9]);
            } else {
                if (state.project.ProjectSubTypeId === 7) {
                    setStreamIds([7]);
                } else if (state.project.ProjectSubTypeId === 8) {
                    setStreamIds([8]);
                } else if (state.project.ProjectSubTypeId === 9) {
                    setStreamIds([10]);
                } else if (state.project.ProjectSubTypeId === 10) {
                    setStreamIds([9]);
                } else if (state.project.ProjectSubTypeId === 11) {
                    setStreamIds([11]);
                }
            }
        }
    }, [state.project]);

    useEffect(() => {
        getSentiment();
    }, [getSentiment]);

    return (
        <div className="sentiment">
            <div className="top-filter">
                <p className="project-name">{state.project?.Description}</p>
                <p className="project-type">{state.project?.ProjectType}</p>
                <span onClick={() => setFiltersOpen(true)} ref={filtersRef}>
                    Filter<i className={`fal ${filtersOpen ? "fa-times" : "fa-sliders-h"}`}></i>
                </span>
                <FiltersMenu
                    open={filtersOpen}
                    setOpen={setFiltersOpen}
                    dateFrom={dateFrom}
                    setDateFrom={setDateFrom}
                    dateTo={dateTo}
                    setDateTo={setDateTo}
                    streamIds={streamIds}
                    setStreamIds={setStreamIds}
                    projectTypeId={state.project?.ProjectTypeId}
                    showDatePicker={true}
                    buttonRef={filtersRef}
                />
            </div>
            <div className="body">
                <Summary sentiment={sentiment} loading={loading} />
                <Heatmap sentiment={sentiment} loading={loading} dateFrom={dateFrom} dateTo={dateTo} projectId={params.projectId} streamIds={streamIds} subfolder={subfolderId!} />
                <DailyInsights sentiment={sentiment} loading={loading} dateFrom={dateFrom} dateTo={dateTo} />
                {/* <WorldMap 
                    sentiment={sentiment} 
                    loading={loading}/> */}
                <Subfolder dateFrom={dateFrom} dateTo={dateTo} projectId={params.projectId} streamIds={streamIds} setSubfolder={setSubfolder} />
                <BreakdownPie sentiment={sentiment} loading={loading} />
            </div>
            <ClipTray />
        </div>
    );
}

export default Sentiment;
